/**
 * DEV-ONLY: URL-driven layout inspector mode (classic vs experimental smart).
 * Query param: `inspect` — see DEVTOOLS.md.
 */

/** @typedef {"classic" | "smart"} InspectorMode */

export const INSPECTOR_MODE_CLASSIC = "classic";
export const INSPECTOR_MODE_SMART = "smart";

/**
 * Map raw `inspect` query values to a stable mode.
 * - `smart`, `2` → smart
 * - `classic`, `1`, `true`, unknown non-empty → classic
 * - empty / absent → classic (default; inspector may still be off)
 */
export function resolveInspectorMode(searchParams) {
  const raw = searchParams.get("inspect");
  if (raw == null || String(raw).trim() === "") {
    return INSPECTOR_MODE_CLASSIC;
  }
  const s = String(raw).trim().toLowerCase();
  if (s === "smart" || s === "2") {
    return INSPECTOR_MODE_SMART;
  }
  return INSPECTOR_MODE_CLASSIC;
}

/**
 * Whether the URL asks for the inspector to be on (any supported non-disabled value).
 * Previously only `inspect=1` activated; now `inspect=classic`, `inspect=smart`, etc. also activate.
 */
export function isInspectorUrlActivated(searchParams) {
  const raw = searchParams.get("inspect");
  if (raw === null || String(raw).trim() === "") {
    return false;
  }
  const s = String(raw).trim().toLowerCase();
  if (["0", "false", "off", "no", "disabled"].includes(s)) {
    return false;
  }
  return true;
}
